type Props = {
  currentPatronId: string | null;
  isOpen: boolean;
  isSlotLockAcquired: boolean;
  membershipTypeId: string | null;
  slotId: string | null;
};

export const canLoadBookingWizardQuery = ({
  currentPatronId,
  isOpen,
  isSlotLockAcquired,
  membershipTypeId,
  slotId,
}: Props) =>
  Boolean(
    isOpen &&
      isSlotLockAcquired &&
      slotId &&
      membershipTypeId &&
      currentPatronId
  );
